import { Clickable, Col, Row, Text } from 'components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const Equipment = ({ data }) => {
  const isMobile = useSelector((state) => state.appState.isMobile),
    { t } = useTranslation(),
    dispatch = useDispatch();

  function handleGetApp() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });
  }

  if (!data?.length) return null;

  if (isMobile)
    return (
      <Col wid="100%" marg="24px 0 0">
        <Row pad="0 16px" between wid="calc(100% - 32px)" center>
          <Text h2>{t('profile.myEquipment')}</Text>

          <Clickable onClick={handleGetApp}>
            <Text b2 bold>
              t('common.seeAll')
            </Text>
          </Clickable>
        </Row>

        <Row start style={{ overflowX: 'scroll', overflowY: 'hidden' }} wid="100vw" marg="8px 0 0">
          {data?.map((x, i) => null)}
        </Row>

        <Row pad="24px 16px 0" between wid="calc(100% - 32px)" center>
          <Text h2>{t('profile.relatedProducts')}</Text>

          <Clickable onClick={handleGetApp}>
            <Text b2 bold>
              {t('common.seeAll')}
            </Text>
          </Clickable>
        </Row>

        <Row start style={{ overflowX: 'scroll', overflowY: 'hidden' }} wid="100vw" marg="8px 0 0">
          {data?.map((x, i) => null)}
        </Row>
      </Col>
    );

  return (
    <Col>
      <Text h2>{t('profile.bidForEquipment')}</Text>
    </Col>
  );
};

export default Equipment;
